<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>助教管理</el-breadcrumb-item>
            <el-breadcrumb-item>助教列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="20">
                    <el-input placeholder="请输入助教编号/昵称/手机/用户名" clearable v-model="queryInfo.query" @clear="getList()" style="width: 350px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                    <el-select  v-model="queryInfo.query1" clearable  placeholder="是否审核" @change="getList()"  style="margin-left: 10px">
                        <el-option label="已审" value="1"></el-option>
                        <el-option label="未审" value="0"></el-option>
                    </el-select>
                    <el-select  v-model="queryInfo.storeid" clearable filterable placeholder="所在门店" @change="getList()"  style="margin-left: 10px">
                      <el-option
                          v-for="item in stores"
                          :key="item.id"
                          :label="item.storename"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-button type="danger" icon="el-icon-delete" @click="openDeleteDialog" style="margin-left: 10px">删除预约订单</el-button>
                </el-col>
                <el-col :span="4">
                    <div style="font-size:12px;color:#ccc;line-height: 40px;">( <i class="el-icon-info" style="color:#ff0000"></i>为用户申请提现标识 )</div>
                </el-col>
            </el-row>
            <br>
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="list" v-loading="loading" style="width: 100%" stripe size="middle" height="700">
                <el-table-column label="ID" type="index"  width="50" fixed></el-table-column>
                <el-table-column label="助教编号" prop="bh" width="80"></el-table-column>
                <el-table-column label="助教昵称" prop="nickname" width="120"></el-table-column>
                <el-table-column label="用户名" prop="username" width="120"></el-table-column>
                <el-table-column label="头像" prop="avatar" width="60">
                    <template slot-scope="scope">
                        <div v-if="scope.row.avatar">
                            <el-popover placement="bottom"  width="310" trigger="click">
                                <div style="text-align: center;">
                                <img :src="imgURL_Front+'static/'+scope.row.avatar" mode="cover"  style="width:300px;height: 300px;border-radius: 5px;"/>
                                </div>
                                <img  slot="reference" :src="imgURL_Front+'static/'+scope.row.avatar" style="height: 30px;width: 30px;border-radius: 50%;">
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="健身地点" prop="storename" width="200" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="联系方式" prop="telephone" width="120"></el-table-column>
                <el-table-column label="价格" prop="price" width="100">
                    <template slot-scope="scope" v-if="scope.row.price">
                        ￥{{scope.row.price}}/小时
                    </template>
                </el-table-column>
                <el-table-column label="展示照片" prop="photos" width="100">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 30px;vertical-align:middle;"
                            :src="require('@/assets/image/preview.png')"
                            :preview-src-list="scope.row.photos">
                        </el-image><span style="color: #ccc;">（{{ scope.row.photos.length }}）</span>
                    </template>
                </el-table-column>
                <el-table-column label="审核" prop="ischeck" width="80">
                    <template  slot-scope="scope">
                        <el-switch active-value="1" inactive-value="0" v-model="scope.row.ischeck" @change="Checked(scope.row,scope.row.id,scope.row.ischeck,scope.row.username, scope.row.photos)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="余额" width="80">
                    <template  slot-scope="scope">
                        ￥{{ scope.row.account }}
                        <el-tooltip class="item" effect="dark" content="此用户申请提现" placement="top">
                            <i v-if="scope.row.tx_check === '0' " class="el-icon-info"  style="color:#ff0000"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="预约记录"  width="80">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-connection" size="mini" @click="YuYue(scope.row.id)" v-permission="'btn:coach:appointment'"></el-button>
                    </template>
                </el-table-column>
                <el-table-column label="提现记录"  width="80">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                            <el-button type="warning" icon="el-icon-sort" size="mini" @click="TiXian(scope.row.username)" v-permission="'btn:coach:withdraw'"></el-button>
                    </template>
                </el-table-column>

                <el-table-column label="申请日期" prop="adddate"></el-table-column>
              <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="{row}">
                  <el-button type="text"  v-permission="'btn:coach:edit'" @click="goEdit(row)">编辑</el-button>
                  <el-button type="text"  v-permission="'btn:coach:delete'" @click="goDel(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--提现记录对话框-->
            <el-dialog title="提现记录" :visible.sync="txDialogVisible" width="60%" >
                <el-card>
                    <!-- {{this.txlist0}} -->
                    <el-table :data="txlist0"  :key="txlist0.id" style="width: 100%"  size="small" height="50" :show-header="false" >
                        <el-table-column label="用户" prop="username"></el-table-column>
                        <el-table-column label="提现金额" prop="amount">
                            <template slot-scope="scope">
                            ￥{{scope.row.amount}}
                        </template>
                        </el-table-column>
                        <el-table-column label="提现时间" prop="reg_time"></el-table-column>
                        <el-table-column label="审核状态">
                             <template>
                                 <el-tag type="warning">待审</el-tag>
                             </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <!--作用域插槽-->
                            <template slot-scope="scope">
                                <!-- {{scope.row}} -->
                                <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.sign" @change="TixianChecked(scope.row)" v-permission="'btn:coach:withdraw:check'"></el-switch>  <span style="color:#ff0000">审核</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
                <br>
                <el-card>
                    <el-table :data="txlist1"  :key="txlist1.id" style="width: 100%" stripe size="small" height="300">
                        <el-table-column label="ID" type="index"></el-table-column>
                        <el-table-column label="提现单号" prop="orderno"></el-table-column>
                        <el-table-column label="用户" prop="username"></el-table-column>
                        <el-table-column label="提现金额" prop="amount">
                            <template slot-scope="scope">
                            ￥{{scope.row.amount}}
                        </template>
                        </el-table-column>
                        <el-table-column label="提现时间" prop="adddate"></el-table-column>
                        <el-table-column label="审核时间" prop="checktime"></el-table-column>
                        <el-table-column label="审核状态">
                             <template>
                                 <el-tag type="success">已审</el-tag>
                             </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-dialog>
            <!--提现记录对话框-->
            <!--预约记录对话框-->
            <el-dialog title="预约记录" :visible.sync="yyDialogVisible" width="60%" >
                <el-card>
                    <el-table :data="yylist"  :key="yylist.id" style="width: 100%" stripe size="small" height="300">
                        <el-table-column label="ID" type="index"></el-table-column>
                        <el-table-column label="预约单号" prop="orderno"  width="150"></el-table-column>
                        <el-table-column label="预约用户" prop="username"  width="120"></el-table-column>
                        <el-table-column label="订单金额" prop="total"  width="100">
                            <template slot-scope="scope">
                            ￥{{scope.row.total}}
                        </template>
                        </el-table-column>
                        <el-table-column label="预约门店" prop="store"></el-table-column>
                        <el-table-column label="预约时间" prop="reserverdate"  width="200">
                            <template slot-scope="scope">
                                {{scope.row.reserverdate}} {{scope.row.reservertime}}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" prop="status">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.status==1" type="success">已支付</el-link>
                                <el-link v-if="scope.row.status==2" type="warning">服务中</el-link>
                                <el-link v-if="scope.row.status==3" type="danger">已完成</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-dialog>
            <!--预约记录对话框-->
            <!--删除预约订单对话框-->
            <el-dialog title="删除助教预约订单" :visible.sync="deleteDialogVisible" width="500px" @close="resetDeleteForm">
                <el-form :model="deleteForm" ref="deleteForm" label-width="100px">
                    <el-form-item label="订单号" prop="orderno">
                        <el-input v-model="deleteForm.orderno" placeholder="请输入订单号" clearable>
                            <el-button slot="append" icon="el-icon-search" @click="queryOrder">查询</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="orderInfo" label="订单信息">
                        <div style="padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                            <p><strong>订单号：</strong>{{ orderInfo.orderno }}</p>
                            <p><strong>预约用户：</strong>{{ orderInfo.username }}</p>
                            <p><strong>预约门店：</strong>{{ orderInfo.store }}</p>
                            <p><strong>预约时间：</strong>{{ orderInfo.reserverdate }} {{ orderInfo.reservertime }}</p>
                            <p><strong>订单金额：</strong>￥{{ orderInfo.total }}</p>
                            <p><strong>状态：</strong>
                                <el-tag v-if="orderInfo.status=='1'" type="success" size="small">已支付</el-tag>
                                <el-tag v-if="orderInfo.status=='2'" type="warning" size="small">服务中</el-tag>
                                <el-tag v-if="orderInfo.status=='3'" type="danger" size="small">已完成</el-tag>
                            </p>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="deleteDialogVisible = false">取 消</el-button>
                    <el-button type="danger" @click="deleteOrder" :disabled="!orderInfo">删 除</el-button>
                </div>
            </el-dialog>
            <!--删除预约订单对话框-->
            <!--编辑助教对话框-->
            <el-dialog title="编辑助教" :visible.sync="updateDialogVisible" width="800px" @close="updateDialogClosed" :destroy-on-close="true">
                <el-form :model="updateForm" :rules="rules" ref="updateForm" label-width="110px">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="助教昵称" prop="nickname">
                        <el-input v-model="updateForm.nickname" placeholder="请输入助教昵称"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="用户名">
                        <el-input :value="updateForm.username" disabled></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="头像" prop="avatar">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadurl"
                        :data="{folderType: ''}"
                        :show-file-list="false"
                        :on-change="avatarChange"
                        :on-success="avatarSuccess"
                        :before-upload="beforeUpload"
                        accept=".jpg,.jpeg,.png">
                      <img v-if="avatarPreview" :src="avatarPreview" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="upload-tip">只能上传jpg/png文件，且不超过2M</div>
                  </el-form-item>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="性别" prop="sex">
                        <el-radio-group v-model="updateForm.sex">
                          <el-radio :label="'0'">男</el-radio>
                          <el-radio :label="'1'">女</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系方式" prop="telephone">
                        <el-input v-model="updateForm.telephone" placeholder="请输入联系方式"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="时间段" prop="shijian">
                    <el-select v-model="updateForm.shijian" multiple placeholder="请选择时间段" style="width: 100%">
                      <el-option
                          v-for="item in timeList"
                          :key="item.id"
                          :label="item.time"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="标签" prop="tag">
                    <el-select v-model="updateForm.tag" multiple placeholder="请选择标签" style="width: 100%">
                      <el-option
                          v-for="item in tagList"
                          :key="item.id"
                          :label="item.tagname"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="健身地点" prop="storeid">
                    <el-select v-model="updateForm.storeid" multiple filterable placeholder="请选择门店" style="width: 100%">
                      <el-option
                          v-for="item in stores"
                          :key="item.id"
                          :label="item.storename"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="简介" prop="Introduction">
                    <el-input type="textarea" :rows="3" maxlength="200" show-word-limit v-model="updateForm.Introduction" placeholder="请输入简介（最多200字）"></el-input>
                  </el-form-item>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="价格" prop="price">
                        <el-input v-model="updateForm.price" placeholder="请输入价格（不少于50）">
                          <template slot="append">/小时</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="审核" prop="ischeck">
                        <el-switch active-value="1" inactive-value="0" v-model="updateForm.ischeck" active-text="是" inactive-text="否"></el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="展示照片" prop="photos">
                    <el-upload
                        ref="imgBroadcastUpload"
                        class="photo-uploader"
                        :auto-upload="true"
                        multiple
                        :file-list="photoList"
                        :data="{folderType: ''}"
                        :http-request="photoRequest"
                        :on-success="photoSuccess"
                        :on-error="photoError"
                        :on-remove="photoRemove"
                        :before-upload="beforeUpload"
                        list-type="picture-card"
                        accept=".jpg,.jpeg,.png"
                        :action="uploadurl">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <div class="upload-tip">只能上传jpg/png文件，且不超过2M</div>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="updateDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="updateCoachs" v-loading="btnLoading">确 定</el-button>
                </div>
            </el-dialog>
            <!--编辑助教对话框-->
        </el-card>
    </div>
</template>
<script>
export default {
    data(){
        return{
          loading:false,
          btnLoading:false,
            imgURL_Front:this.GLOBAL.imgURL_Front,
            queryInfo: {
                query: '',
                query1: '',
              storeid: null,
                pagenum: 1,
                pagesize: 20
            },
            txDialogVisible:false,
            yyDialogVisible:false,
            deleteDialogVisible:false,
            updateDialogVisible:false,
            txlist0:[],
            txlist1:[],
            yylist:[],
            list: [],
            total: 0,
            srcList:[],
            admin_token:'',
            deleteForm: {
                orderno: ''
            },
            updateForm: {
              id: null,
              nickname: '',
              username: '',
              avatar: '',
              sex: '0',
              telephone: '',
              storeid: [],
              photos: [],
              score: 0,
              lesson: 0,
              shijian: [],
              tag: [],
              Introduction: '',
              price: '',
              city: '',
              ischeck: '0',
              status: '0'
            },
          orderInfo: null,
          stores: [],
          uploadurl: this.GLOBAL.imgURL+'uploadtoxcx/',
          timeList: [],
          tagList: [],
          photoList: [],
          photoUploadQueue: Promise.resolve(),
          avatarPreview: '',
          rules:{
            nickname:[
              {required: true, message: '请输入助教昵称', trigger: 'blur'},
            ],
            telephone:[
              {required: true, message: '请输入联系方式', trigger: 'blur'},
              {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
            ],
            storeid:[
              {required: true, type: 'array', min: 1, message: '请至少选择一个健身地点', trigger: 'change'},
            ],
            shijian:[
              {required: true, type: 'array', min: 1, message: '请至少选择一个时间段', trigger: 'change'},
            ],
            tag:[
              {required: true, type: 'array', min: 1, message: '请至少选择一个标签', trigger: 'change'},
            ],
            price:[
              {
                validator: (rule, value, callback) => {
                  if (value === '' || value === null || value === undefined) {
                    callback(new Error('请输入价格'))
                  } else if (Number(value) < 50) {
                    callback(new Error('价格不能小于50'))
                  } else {
                    callback()
                  }
                },
                trigger: 'blur'
              }
            ],
            photos:[
              {
                validator: (rule, value, callback) => {
                  if (Array.isArray(value) && value.length >= 6) {
                    callback()
                  } else {
                    callback(new Error('展示照片至少需要6张'))
                  }
                },
                trigger: 'change'
              }
            ]
          }
        }
    },
    created() {
      this.getStoreList()
      this.getTimeList()
      this.getTagList()
      this.getList()
    },
    mounted(){
      this.admin_token = window.sessionStorage.getItem('admin_token')
    },
    methods:{
        async getStoreList(){
          const { data:res } = await this.$http.get('open-account/getStoresAll/')
          this.stores = res.data
        },
        async getList() {
          this.loading = true
           const { data: res} = await this.$http.get('coachlist/',{ params: this.queryInfo })
          this.loading = false
           if(res.status == 1){
                this.total = res.data.totalCount;
                this.list = res.data.list.map(v => {
                //在返回的数据里增加一条数据
                // console.log(v.fields)
                return v.fields
                })
           }
            for (let index = 0; index < res.data.list.length; index++) {
              this.list[index].id= res.data.list[index].pk;
            }
        },
        handleSizeChange(newSize){
            // console.log(newSize)
             this.queryInfo.pagesize = newSize
             this.getList()
        },
        handleCurrentChange(newPage){
            // console.log(newPage)
             this.queryInfo.pagenum = newPage
             this.getList()
        },
        async DelList(id){
          const confirmResult = await this.$confirm('是否要删除此订单吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(err => err)

          if (confirmResult !== 'confirm'){
              return this.$message.info('已取消删除！')
          }
          const { data: res } = await this.$http.get('orderdel/'+ id)
          // console.log(res)
          if (res.status === 0) {
              this.$message({message: '删除成功！',type: 'success'})
          }
          this.getOrderList()
        },
        Preview(photos){
          console.log(photos);
        },
        async Checked(row, id,sign,username, photos){
          if (!photos || photos.length === 0) {
            const confirmResult = await this.$confirm('当前用户照片为空是否通过?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm'){
              row.ischeck = row.ischeck == '1' ? '0' : '1'
              return
            }
          }
            const { data: res} = await this.$http.get('coachcheck/',{ params:{ id:id,sign:sign,username:username,admin_token:this.admin_token }})
            if(res.status === 0){
               this.$message({message: '审核通过！',type: 'success'})
               this.getList()
            }
            if(res.status === 1){
               this.$message({message: '审核取消！',type: 'warning'})
               this.getList()
            }
        },
        async TixianChecked(row){
          console.log(row.id);
          const confirmResult = await this.$confirm('确定要申请此提现吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).catch(err => err)

          if (confirmResult !== 'confirm'){
              return this.$message.info('已取消删除！')
          }
          try {
              const loading = this.$loading({
                  lock: true,
                  text: '正在提现中，请勿关闭页面！',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              });
              const { data: res} = await this.$http.post('checktixian/',{ id:row.id,admin_token:this.admin_token});
              loading.close();
              if(res.status === 0){
               this.$message({message: '提现审核成功！',type: 'success'})
                this.txDialogVisible = false
              } else {
                row.sign = '0'
                this.$message({message: '提现审核失败！',type: 'danger'})
              }
          } catch (error) {
              console.error("请求出错：", error);
          }
        },
      async TiXian(username){
            this.txDialogVisible = true
            const { data: res} = await this.$http.post('tixianlist/',{ username:username })
            this.txlist0 = res.arr0
            this.txlist1 = res.arr1
      },
      async YuYue(coachid){
          console.log(coachid);
            this.yyDialogVisible = true
            const { data: res} = await this.$http.post('yuyuelist/',{ coachid:coachid })
            if(res.status == 0){
              this.yylist = res.data
            }
         },
      // 打开删除对话框
      openDeleteDialog(){
          this.deleteDialogVisible = true
          this.orderInfo = null
          this.deleteForm.orderno = ''
      },
      // 查询订单
      async queryOrder(){
          if(!this.deleteForm.orderno || this.deleteForm.orderno.trim() === ''){
              this.$message.warning('请输入订单号')
              return
          }

          try {
              // 调用查询接口获取订单详情
              const { data: res } = await this.$http.post('queryreserve/',{ orderno: this.deleteForm.orderno.trim() })

              if(res.status === 1){
                  this.$message.error(res.message || '订单不存在')
                  this.orderInfo = null
                  return
              }

              // 显示订单详细信息
              if(res.status === 0 && res.data){
                  this.orderInfo = res.data
                  this.$message.success('查询成功，请确认删除')
              }
          } catch (error) {
              this.$message.error('查询失败：' + (error.message || '网络异常'))
              this.orderInfo = null
          }
      },
      // 删除订单
      async deleteOrder(){
          if(!this.orderInfo){
              this.$message.warning('请先查询订单')
              return
          }

          const confirmResult = await this.$confirm('确定要删除此预约订单吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).catch(err => err)

          if (confirmResult !== 'confirm'){
              return this.$message.info('已取消删除！')
          }

          try {
              const { data: res } = await this.$http.post('deletereserve/',{ orderno: this.deleteForm.orderno.trim() })

              if(res.status === 0){
                  this.$message.success('删除成功！')
                  this.deleteDialogVisible = false
                  this.resetDeleteForm()
              } else if(res.message === '订单不存在'){
                  this.$message.error('订单不存在')
              } else {
                  this.$message.error(res.message || '删除失败')
              }
          } catch (error) {
              this.$message.error('删除失败：' + (error.message || '网络异常'))
          }
      },
      // 重置删除表单
      resetDeleteForm(){
          this.deleteForm.orderno = ''
          this.orderInfo = null
      },
      // 获取时间段列表
      async getTimeList(){
        const { data: res } = await this.$http.get('timeInfo/list')
        if (res.status === 0) {
          this.timeList = res.data
        }
      },
      // 获取标签列表
      async getTagList(){
        const { data: res } = await this.$http.get('tagInfo/list')
        if (res.status === 0) {
          this.tagList = res.data
        }
      },
      // 头像选择后立即本地预览
      avatarChange(file){
        if (file.raw) {
          this.avatarPreview = URL.createObjectURL(file.raw)
        }
      },
      // 头像上传成功
      avatarSuccess(response){
        let raw = response.picname || response.url || (response.data && (response.data.picname || response.data.url))
        if (raw) {
          // 若返回的是完整地址，只取文件名（与列表头像的存储格式一致）
          if (/^https?:\/\//.test(raw)) {
            raw = raw.split('/').pop()
          }
          this.updateForm.avatar = raw
          this.$message.success('头像上传成功')
        } else {
          this.$message.error(response.msg || '上传失败')
        }
      },
      // 展示照片上传前校验
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!')
        }
        return isLt2M
      },
      // 展示照片上传成功（记录文件名；el-upload 内部列表会自动显示本地预览，无需再手动维护 photoList）
      photoSuccess(response, file){
        let raw = response.picname || response.url || (response.data && (response.data.picname || response.data.url))
        if (raw) {
          const name = raw.split('/').pop()
          this.updateForm.photos.push(name)
          this.$refs.updateForm && this.$refs.updateForm.validateField('photos')
        } else {
          this.$message.error(response.msg || '上传失败')
        }
      },
      // 串行上传：多张图片一次只上传一张，避免并发请求导致服务端只保存第一张
      photoRequest(options){
        const task = this.photoUploadQueue.then(() => {
          // 已删除的排队图片直接跳过，不再上传
          if (options._cancelled) return { aborted: true }
          return this.doPhotoUpload(options)
        })
        // 队列中单个任务失败/取消不影响后续上传
        this.photoUploadQueue = task.catch(() => {})
        // 对外暴露给 el-upload 的结果；被取消的图片不触发 on-success/on-error
        let resolveOuter, rejectOuter
        const outer = new Promise((resolve, reject) => {
          resolveOuter = resolve
          rejectOuter = reject
        })
        task.then(data => {
          if (data && data.aborted) return
          resolveOuter(data)
        }, err => rejectOuter(err))
        return {
          then: (resolve, reject) => outer.then(resolve, reject),
          catch: fn => outer.catch(fn),
          // 删除图片时取消上传：中止正在进行的请求，并跳过尚未开始的排队任务
          abort: () => {
            options._cancelled = true
            const cur = this._uploadingTask
            if (cur && cur.file === options.file) {
              cur.xhr.onload = null
              cur.xhr.onerror = null
              try { cur.xhr.abort() } catch (e) {}
            }
          }
        }
      },
      doPhotoUpload(options){
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest()
          this._uploadingTask = { xhr: xhr, file: options.file }
          const done = () => {
            if (this._uploadingTask && this._uploadingTask.xhr === xhr) {
              this._uploadingTask = null
            }
          }
          xhr.open('POST', options.action, true)
          if (options.withCredentials && 'withCredentials' in xhr) {
            xhr.withCredentials = true
          }
          const headers = options.headers || {}
          Object.keys(headers).forEach(key => {
            if (headers[key] !== null && headers[key] !== undefined) {
              xhr.setRequestHeader(key, headers[key])
            }
          })
          const formData = new FormData()
          if (options.data) {
            Object.keys(options.data).forEach(key => formData.append(key, options.data[key]))
          }
          formData.append(options.filename || 'file', options.file)
          if (xhr.upload) {
            xhr.upload.onprogress = (e) => {
              if (e.lengthComputable && options.onProgress) {
                options.onProgress({ percent: Math.round(e.loaded / e.total * 100) })
              }
            }
          }
          xhr.onabort = () => {
            done()
            resolve({ aborted: true })
          }
          xhr.onerror = () => {
            done()
            reject(new Error('网络错误'))
          }
          xhr.onload = () => {
            done()
            if (xhr.status < 200 || xhr.status >= 300) {
              reject(new Error('上传失败'))
              return
            }
            let data = xhr.responseText
            try {
              data = JSON.parse(data)
            } catch (e) {}
            resolve(data)
          }
          xhr.send(formData)
        })
      },
      photoError(){
        this.$message.error('图片上传失败，请重试')
      },
      // 展示照片移除（photoList 仅用于初始回显，删除时不要改它，否则会触发 el-upload 重建列表把新上传的照片清掉）
      photoRemove(file){
        const raw = file.response ? (file.response.picname || file.response.url) : file.name
        const name = raw.split('/').pop()
        const index = this.updateForm.photos.indexOf(name)
        if (index > -1) {
          this.updateForm.photos.splice(index, 1)
        }
        this.$refs.updateForm && this.$refs.updateForm.validateField('photos')
      },
      // 编辑助教信息
      goEdit(row){
          this.updateForm.id = row.id
          this.updateForm.nickname = row.nickname || ''
          this.updateForm.username = row.username || ''
          this.updateForm.avatar = row.avatar || ''
          this.avatarPreview = this.updateForm.avatar ? this.imgURL_Front + 'static/' + this.updateForm.avatar : ''
          this.updateForm.sex = row.sex !== undefined && row.sex !== null ? String(row.sex) : '0'
          this.updateForm.telephone = row.telephone || ''
          this.updateForm.Introduction = row.Introduction || ''
          this.updateForm.price = row.price !== undefined && row.price !== null ? String(row.price) : ''
          this.updateForm.city = row.city || ''
          this.updateForm.score = row.score !== undefined && row.score !== null ? Number(row.score) : 0
          this.updateForm.lesson = row.lesson !== undefined && row.lesson !== null ? Number(row.lesson) : 0
          this.updateForm.ischeck = row.ischeck !== undefined && row.ischeck !== null ? String(row.ischeck) : '0'
          this.updateForm.status = row.status !== undefined && row.status !== null ? String(row.status) : '0'
          // 健身地点
          let storeArr = String(row.storeid || '').split(',').filter(Boolean)
          this.updateForm.storeid = storeArr.map(item => parseInt(item))
          // 时间段
          let timeArr = String(row.shijian || '').split(',').filter(Boolean)
          this.updateForm.shijian = timeArr.map(item => parseInt(item))
          // 标签
          let tagArr = String(row.tag || '').split(',').filter(Boolean)
          this.updateForm.tag = tagArr.map(item => parseInt(item))
          // 展示照片
          let photos = row.photos || []
          if (typeof photos === 'string') {
            photos = photos.split(',').filter(Boolean)
          }
          // 存储只保留文件名（与其它上传规则一致），展示用完整URL
          this.updateForm.photos = photos.map(p => p.split('/').pop())
          this.photoList = photos.map(p => {
            // 列表返回的是完整URL，直接使用；否则拼接前缀
            const url = /^https?:\/\//.test(p) ? p : this.imgURL_Front + 'static/' + p
            return { name: p.split('/').pop(), url: url }
          })
          this.updateDialogVisible = true
      },
      // 删除助教信息
      async goDel(row){
        const confirmResult = await this.$confirm('确定要删除助教'+row.nickname+'吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)

        if (confirmResult !== 'confirm'){
          return this.$message.info('已取消删除！')
        }

        const { data: res } = await this.$http.get('deleteCoach/' + row.id)
        if(res.status === 0){
          this.$message.success('删除成功！')
          this.getList()
        } else {
          this.$message.error(res.message || '删除失败')
        }
      },
      updateCoachs() {
        // 等待所有图片上传完成后再提交
        const uploadRef = this.$refs.imgBroadcastUpload
        const pending = uploadRef && uploadRef.uploadFiles && uploadRef.uploadFiles.some(f => f.status === 'ready' || f.status === 'uploading')
        if (pending) {
          return this.$message.warning('图片正在上传，请稍候再试')
        }
        this.$refs.updateForm.validate(async valid => {
          if (valid) {
            this.btnLoading = true
            const params = {
              id: this.updateForm.id,
              nickname: this.updateForm.nickname,
              avatar: this.updateForm.avatar,
              sex: this.updateForm.sex,
              telephone: this.updateForm.telephone,
              storeid: this.updateForm.storeid.join(','),
              photos: this.updateForm.photos.join(','),
              score: this.updateForm.score,
              lesson: this.updateForm.lesson,
              shijian: this.updateForm.shijian.join(','),
              tag: this.updateForm.tag.join(','),
              Introduction: this.updateForm.Introduction,
              price: this.updateForm.price,
              city: this.updateForm.city,
              ischeck: this.updateForm.ischeck,
              status: this.updateForm.status,
              admin_token: this.admin_token
            }
            const { data: res } = await this.$http.post('updateCoachInfo/', params)

            this.btnLoading = false
            if(res.status === 0){
              this.$message.success('编辑成功！')
              this.updateDialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.message || '编辑失败')
            }
          }
        })
      },
      updateDialogClosed(){
        this.$refs.updateForm.resetFields()
        this.photoList = []
        this.avatarPreview = ''
      }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
    .avatar {
        width: 100px;
        height: 100px;
        display: block;
        border-radius: 50%;
    }
    .upload-tip {
        font-size: 12px;
        color: #909399;
        line-height: 20px;
    }
    /* 去除展示照片列表的过渡动画 */
    .photo-uploader >>> .el-upload-list__item {
        transition: none !important;
    }
    .photo-uploader >>> .el-upload-list__item-actions {
        transition: none !important;
    }
    .photo-uploader >>> .el-upload-list__item img {
        transition: none !important;
    }
</style>
